module.exports = __webpack_public_path__ + "img/test.07dc29ff.svg";